import { Kontakt } from "../../../ts/Kontakt";
import { Obrat, RawObrat } from "../../../ts/Obraty";
import { Filter } from "./Obraty";

export const MAP_CSV_OBRATY_TO_JSON = (data: any) => {
  console.log(data)
  if (!Array.isArray(data) || data.length === 0) {
    return false;
  }

  const array: RawObrat[] = [];

  for (const d of data) {
    if (!d.id_klienta || !d.rok || !d.mesiac || !d.suma) {
      console.log(d)
      return false;
    }

    array.push({
      id_klienta: parseInt(d.id_klienta.trim()),
      rok: parseInt(d.rok.trim()),
      mesiac: parseInt(d.mesiac.trim()),
      suma: parseFloat(d.suma.trim()),
    });
  }

  return array;
};

const IS_MATCH_WITH_FILTER = (filter: Filter, o: Obrat): boolean => {
  let criteriaCheck = true;

  return criteriaCheck;
};

const IS_ALREADY_IN_ARRAY = (obrat: Obrat, obraty: Obrat[]): boolean => {
  if (obraty.find((o) => o._id === obrat._id)) return true;

  return false;
};

const GET_SUMA_FOR_OBRATY = (o: Obrat, obraty: Obrat[]): number => {
  return obraty
    .filter(
      (so) =>
        so.kontakt._id === o.kontakt._id &&
        so.rok === o.rok &&
        so.mesiac === o.mesiac
    )
    .map((o) => o.suma)
    .reduce((a, b) => a + b);
};

const getSumaForMesic = (
  obraty: Obrat[],
  kontakt: string,
  rok: number,
  mesiac: number
): number | undefined => {
  let filteredSumy = obraty
    .filter(
      (obr) =>
        obr.kontakt._id === kontakt && obr.rok === rok && obr.mesiac === mesiac
    )
    .map((obr) => obr.suma);

  if (filteredSumy.length === 0 || !filteredSumy) return undefined;

  return filteredSumy.reduce((a, b) => a + b);
};

export type MesicString =
  | "leden"
  | "unor"
  | "brezen"
  | "duben"
  | "kveten"
  | "cerven"
  | "cervenec"
  | "srpen"
  | "zari"
  | "rijen"
  | "listopad"
  | "prosinec";

export type Mesic = {
  nazev:
    | "leden"
    | "unor"
    | "brezen"
    | "duben"
    | "kveten"
    | "cerven"
    | "cervenec"
    | "srpen"
    | "zari"
    | "rijen"
    | "listopad"
    | "prosinec";
  suma: number | undefined;
};

export interface ObratMesice {
  _id: string;
  date: string;
  kontakt: Kontakt;
  rok: number;
  spolu: number | undefined;
  mesice: Mesic[];
}

export interface ObratMesiceSingle {
  _id: string;
  id_klienta: string;
  spolocnost: string;
  leden: number | undefined | string;
  unor: number | undefined | string;
  brezen: number | undefined | string;
  duben: number | undefined | string;
  kveten: number | undefined | string;
  cerven: number | undefined | string;
  cervenec: number | undefined | string;
  srpen: number | undefined | string;
  zari: number | undefined | string;
  rijen: number | undefined | string;
  listopad: number | undefined | string;
  prosinec: number | undefined | string;
  rok: number;
  spolu: number | string | undefined;
  obchodnik?: string;
  skupina?: string;
  mesto?: string;
  okres?: string;
}

export const GET_MESICE_OBRATY = (obraty: Obrat[]): ObratMesice[] => {
  let mesiceObraty: ObratMesice[] = [];

  obraty.forEach((o) => {
    if (
      !mesiceObraty.find(
        (m) => m.kontakt._id === o.kontakt._id && m.rok === o.rok
      )
    ) {
      let mesice: Mesic[] = [
        {
          nazev: "leden",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 1),
        },
        {
          nazev: "unor",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 2),
        },
        {
          nazev: "brezen",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 3),
        },
        {
          nazev: "duben",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 4),
        },
        {
          nazev: "kveten",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 5),
        },
        {
          nazev: "cerven",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 6),
        },
        {
          nazev: "cervenec",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 7),
        },
        {
          nazev: "srpen",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 8),
        },
        {
          nazev: "zari",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 9),
        },
        {
          nazev: "rijen",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 10),
        },
        {
          nazev: "listopad",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 11),
        },
        {
          nazev: "prosinec",
          suma: getSumaForMesic(obraty, o.kontakt._id, o.rok, 12),
        },
      ];

      mesiceObraty.push({
        _id: o._id,
        date: o.date,
        kontakt: o.kontakt,
        rok: o.rok,
        mesice,
        spolu: mesice
          .map((m) => m.suma)
          .reduce((a, b) => {
            let _a = undefined,
              _b = undefined;

            if (typeof a === "undefined") _a = 0;
            else _a = a;
            if (typeof b === "undefined") _b = 0;
            else _b = b;

            return _a + _b;
          }),
      });
    }
  });

  return mesiceObraty;
};

export const onlyUnique = (value: any, index: number, self: any) => {
  return self.indexOf(value) === index;
};

export const GET_SUM_OBRATY = (obraty: Obrat[]): ObratMesice[] => {
  let sumObraty: Obrat[] = [];

  obraty.forEach((o) => {
    let findElement = sumObraty.find(
      (so) =>
        so.kontakt._id === o.kontakt._id &&
        so.rok === o.rok &&
        so.mesiac === o.mesiac
    );

    if (!findElement)
      sumObraty.push({ ...o, suma: GET_SUMA_FOR_OBRATY(o, obraty) });
  });

  return GET_MESICE_OBRATY(sumObraty);
};

export const GET_FILTERED_OLD_OBRATY = (
  filters: Filter[],
  obraty: Obrat[]
): Obrat[] => {
  let filteredObraty: Obrat[] = [];

  obraty.forEach((o) => {
    filters.forEach((f) => {
      if (IS_MATCH_WITH_FILTER(f, o) && !IS_ALREADY_IN_ARRAY(o, filteredObraty))
        filteredObraty.push(o);
    });
  });

  return filteredObraty;
};

export const GET_FILTERED_OBRATY = (
  filters: Filter[],
  obraty: Obrat[]
): ObratMesice[] => {
  let filteredObraty: Obrat[] = [];

  obraty.forEach((o) => {
    filters.forEach((f) => {
      if (IS_MATCH_WITH_FILTER(f, o) && !IS_ALREADY_IN_ARRAY(o, filteredObraty))
        filteredObraty.push(o);
    });
  });

  return GET_MESICE_OBRATY(filteredObraty);
};

export const GET_OBRATY_BY_FILTER = (
  filter: Filter,
  obraty: Obrat[]
): Obrat[] => {
  let filteredObraty: Obrat[] = [];

  obraty.forEach((o) => {
    if (IS_MATCH_WITH_FILTER(filter, o)) {
      filteredObraty.push(o);
    }
  });

  return filteredObraty;
};

export const IS_OBJECT_DEFINED = (val: any) => {
  return !(val === null || val === undefined || val === "");
};

export const IS_FILTER_EMPTY = (filter: Filter) => {
  let isFilterEmpty = true;

  Object.keys(filter).forEach((k: string) => {
    if (filter[k as keyof Filter]?.label) {
      isFilterEmpty = false;
    }
  });

  return isFilterEmpty;
};
